<template>
    <Transfer :data="data"
              :target-keys="targetKeys"
              :render-format="render"
              @on-change="handleChange"
              :list-style="listStyle"></Transfer>
</template>
<script>
    import request from '@/utils/request'

    export default {
        name: 'userlist',
        props: {
            selectedUsers: {
                type: Array
            }
        },
        data() {
            return {
                data: [],
                targetKeys: [],
                listStyle: {
                    height: '350px'
                }
            }
        },
        methods: {
            getMockData() {
                let component = this;
                request.post('/api/User/GetUserToTransfer').then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.data = response.data;
                }).catch(function (error) {
                })
            },
            getTargetKeys() {
                
            },
            render(item) {
                return item.label;
            },
            handleChange(newTargetKeys, direction, moveKeys) {
                console.log(newTargetKeys);
                console.log(direction);
                console.log(moveKeys);
                this.targetKeys = newTargetKeys;
            }
        },
        watch: {
            selectedUsers(val) {
                this.targetKeys = val;
            }
        },
        created: function () {
            this.getMockData();
        }
    }
</script>
